// extracted by mini-css-extract-plugin
export default {"container":"style_container__-FpJv","my":"style_my__2h5vN","message":"style_message__dDesZ","text":"style_text__H+jrz","info":"style_info__zBsL2","date":"style_date__nl4KG"};